import IStatistics from './IStatistics'

/**
 * 叠置操作基类
 * 规定数据格式
 * 不做其他处理
 */
export default class Query extends IStatistics {
    /**
     * @description 处理
     * @api
     * @param {Array} fc
     * @param {Array} expressions
     * @param {String} logicRelation
     */
    async _process(fc, expressions, logicRelation = 'and') {
        return fc.filter(f => {
            let flag = true

            for (let i = 0; i < expressions.length; i++) {
                const { key, relation, value } = expressions[i]

                let _flag = f.properties.hasOwnProperty(key)

                // 存在属性，进行条件判断
                if (_flag) {
                    // 数字类型
                    if (['>', '<', '>=', '<='].includes(relation)) {
                        _flag = eval(
                            `${+f.properties[key]} ${relation} ${+value}`
                        )
                    }
                    /***************统一转成字符串判断*************** */
                    if (relation === '=') {
                        _flag = f.properties[key] + '' == value
                    }
                    if (relation === '!=') {
                        _flag = f.properties[key] + '' != value
                    }
                    if (relation === 'like') {
                        _flag = (f.properties[key] + '').includes(value)
                    }
                }

                if (i === 0) {
                    flag = flag && _flag
                }

                // and关系
                if (logicRelation == 'and') {
                    flag = flag && _flag

                    if (flag) {
                        continue
                    } else {
                        break
                    }
                }
                // or关系
                else {
                    flag = flag || _flag

                    if (flag) {
                        break
                    } else {
                        continue
                    }
                }
            }

            return flag
        })
    }
}
